import { useState, useEffect } from 'react';

// Define a type that includes only the properties of 'Window' that return numbers
type WindowProperty = keyof Pick<Window, 'scrollY'>;

const useWindowProperty = (property: WindowProperty) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setValue(window[property]);
    };

    handleResize();

    window.addEventListener('scroll', handleResize);

    return () => window.removeEventListener('scroll', handleResize);
  }, [property]);

  return value;
};

export default useWindowProperty;
